import { createSlice } from '@reduxjs/toolkit';

export const connectionState = {
  DISCONNECTED: 0,
  DISCONNECTING: 1,
  CONNECTED: 2,
  CONNECTING: 3,
};

export const connectionSlice = createSlice({
  name: 'connection',
  initialState: {
    displayState: connectionState.DISCONNECTED,
    lastMessageSent: null,
    disconnectCount: 0,
  },
  reducers: {
    setDisplayState: (state, action) => {
      state.displayState = action.payload;
      if (action.payload === connectionState.DISCONNECTED) {
        state.disconnectCount++;
      }
    },
    setLastMessageSent: (state, action) => {
      state.lastMessageSent = Date.now();
    },
    resetDisconnectCount: (state, action) => {
      state.disconnectCount = 0;
    }
  }
});

export const getDisplayState = (state) => state.connection.displayState;
export const getLastMessageSent = (state) => state.connection.lastMessageSent;
export const getDisconnectCount = (state) => state.connection.disconnectCount;

export default connectionSlice.reducer;
